import { render } from "./CookieSettingsForm.vue?vue&type=template&id=7c5b699c"
import script from "./CookieSettingsForm.vue?vue&type=script&lang=js"
export * from "./CookieSettingsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__